import api from '../../utils/api'

const API_BASE_URL = "/ast/ASTQrdet";

const ASTQrdetService = {
  async findAll(recordFilter: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`, {
      params: recordFilter,
    });
    return response.data;
  },

  async getItemById(qrId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${qrId}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(qrId: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${qrId}`, item);
    return response.data;
  },

  async delete(qrId: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${qrId}`);
    return response.data;
  },

  async getItemsByQrBatchId(qrBatchId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all-by-qr-batch-id/${qrBatchId}`);
    return response.data;
  },

  async findOneNoAccess(qrId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one-no-access/${qrId}`);
    return response.data;
  },

  async getItemsByInstrumentId(instrumentId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all-by-instrument-id/${instrumentId}`);
    return response.data;
  },

  async findOneInstrumentBySN(snNo: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one-by-sn/${encodeURIComponent(snNo)}`);
    return response.data;
  },

  async findOneQrByInstrumentId(instrumentId: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one-by-instrument-id/${instrumentId}`);
    return response.data;
  },

};

export default ASTQrdetService;